var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditImageName(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7961 2.77835L13.7216 1.70385C13.3638 1.34578 12.8946 1.16675 12.4254 1.16675C11.9562 1.16675 11.4869 1.34578 11.1289 1.70357L1.03475 11.7977L0.670951 15.0696C0.625118 15.4815 0.949673 15.8333 1.35272 15.8333C1.37821 15.8333 1.40371 15.8319 1.42977 15.829L4.69938 15.4678L14.7964 5.37077C15.5122 4.65492 15.5122 3.4942 14.7961 2.77835ZM4.27858 14.5924L1.61368 14.8877L1.91045 12.2188L9.46973 4.6595L11.8407 7.0305L4.27858 14.5924ZM14.1481 4.72281L12.4887 6.38225L10.1177 4.01125L11.7771 2.35182C11.9501 2.1788 12.1805 2.08341 12.4254 2.08341C12.6703 2.08341 12.9003 2.1788 13.0736 2.35182L14.1481 3.42631C14.5053 3.78381 14.5053 4.36531 14.1481 4.72281Z",
    fill: "#0e0333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditImageName);
export default __webpack_public_path__ + "static/media/edit-image-name.4eba331368a78197a4ca1235ac505665.svg";
export { ForwardRef as ReactComponent };